import { render } from "./EmptyCollection.vue?vue&type=template&id=27f7ca92"
import script from "./EmptyCollection.vue?vue&type=script&lang=js"
export * from "./EmptyCollection.vue?vue&type=script&lang=js"

import "./EmptyCollection.vue?vue&type=style&index=0&id=27f7ca92&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__